import './ccf-assignement-box-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAssignementBoxIconProps extends SvgIconProps {
  bgColor?:string;
}

/**
 * CcfAssignementBoxIcon used to disply assignment icon in the navigation panel
 * @param props - CcfAssignementBoxIconProps
 * @example -- <CcfAssignementBoxIcon />
 */
export function CcfAssignementBoxIcon(props: CcfAssignementBoxIconProps) {
  return (
      <SvgIcon {...props}>
        <g id="Assignment_Box" data-name="Assignment Box" clipPath="url(#clip-Assignment_Box)">
          <rect width="20" height="20" fill={props.bgColor? props.bgColor:"#fff"}/>
          <g id="office">
            <path id="Path_24908" data-name="Path 24908" d="M18,0H2A2.006,2.006,0,0,0,0,2V18a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V2A2.006,2.006,0,0,0,18,0Zm0,18H2V14H6v1a.945.945,0,0,0,1,1h6a.945.945,0,0,0,1-1V14h4Zm0-6H13a.945.945,0,0,0-1,1v1H8V13a.945.945,0,0,0-1-1H2V2H18Z"/>
            <path id="Path_24909" data-name="Path 24909" d="M6.4,6.4h12v2H6.4Z" transform="translate(-2.4 -2.4)"/>
            <path id="Path_24910" data-name="Path 24910" d="M6.4,12.8h12v2H6.4Z" transform="translate(-2.4 -4.8)"/>
          </g>
        </g>
      </SvgIcon>
  );
}

export default CcfAssignementBoxIcon;
